module.exports = __webpack_public_path__ + "img/lg_ring_y_skip_1_0.5b871b3b.png";